// Status pill + channel chips + launched/created meta. Sits just under the
// page header so the header stays clean (title + action buttons only).

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../../ui';
import StatusPill from '../dashboard/StatusPill';
import ChannelChips from '../dashboard/ChannelChips';
import { CAMPAIGN_STATUS } from '../../constants';

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.NEU_600};
`;

const Sep = styled.span`
  color: ${({ theme }) => theme.colors.NEU_300};
`;

const formatDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }); } catch { return iso; }
};

const CampaignStatusStrip = ({ campaign }) => {
  const { t } = useTranslation();
  return (
    <Wrap>
      <StatusPill status={campaign.status} theme={theme} />
      <ChannelChips campaign={campaign} theme={theme} />
      <Sep>·</Sep>
      <span>
        {campaign.status === CAMPAIGN_STATUS.ACTIVE
          ? t('campaigns.header.launched', 'Launched {{when}}', { when: formatDate(campaign.schedule?.email?.sendAt) })
          : t('campaigns.header.created', 'Created {{when}}', { when: formatDate(campaign.createdAt) })}
        {campaign.createdBy?.name && (
          <> · {t('campaigns.header.by', 'by {{name}}', { name: campaign.createdBy.name })}</>
        )}
      </span>
    </Wrap>
  );
};

export default CampaignStatusStrip;
